const apiPath = {
  loginUser: "/v1/admin/login",
  getConfigApi: "/v1/user/config",
  getEarnings: "/v1/admin/earnings",
  getLogs: "/v1/admin/logs",
  getUsers: "/v1/admin/user",
  createUser: "/v1/admin/user",
  updateUser: "/v1/admin/user",
  changeUserStatus: "/v1/admin/user/change-status",
  refreshToken: "/v1/user/refresh-token",
  seriesList: "/v1/user/match/series",
  matchList: "/v1/user/match/list",
  refreshAmount: "/v1/admin/refresh-amount",
  userProfile: "/v1/user/profile",
  userProfileUpdate: "/v1/user/profile-update",
  userEditStake: "/v1/user/edit-stake",
  userEditOneClickStake: "/v1/user/edit-one-click-stake",
  activityLogs: "/v1/user/activity-logs",
  transactionLogs: "/v1/user/transaction/logs",
  matchDetail: "/v1/user/match/detail",
  matchScore: "/v1/user/match/score",
  sportsList: "/v1/user/sport/list",
  inPlayCount: "/v1/user/sport/inplay-count",
  betfairPlaceBet: "/v1/user/match/betfaire-place-bet",
  soccerPlaceBet: "/v1/user/match/soccer-place-bet",
  tennisPlaceBet: "/v1/user/match/tennis-place-bet",
  userInPlaySport: "/v1/user/sport",
  bookmakerBet: "/v1/user/match/bookmaker-place-bet",
  betPosition: "/v1/user/match/get-bet-positions",
  betEventsBetPosition: "/v1/user/match/get-events-bet-positions",
  multiEventPlaceBet: "/v1/user/match/multiple-event-place-bet",
  getCurrentBetsExchanges: "/v1/user/match/my-bets",
  cancelUnmatchedBets: "/v1/user/match/clear-unmatched-bet",
  getBookmakerBets: "/v1/user/match/my-bookmaker-bets",
  getFancyBets: "/v1/user/match/my-fancy-bets",
  getSportsBook: "/v1/user/match/my-sport-book-bets",
  fancyBetPlace: "/v1/user/match/fancy-place-bet",
  multiMarket: "/v1/user/sport/multi-market",
  preminumFancyBets: "/v1/user/match/premium-fancy-place-bet",
  addMatchInMultiMarket: "/v1/user/sport/multi-market",
  getPremiumFancy: "/v1/cron/premium-fancy",
  getBetsData: "/v1/user/match/events-bets",
  getHistory: "/v1/user/match/bet-history",
  messageList: "/v1/user/message/list",
  userSubscribe: "/v1/user/subscribe",
  adminSetting: "/v1/user/site-setting/site-setting-list",
  getWalletTransactions: "/v1/admin/wallet-transaction",
  getTransactions: "/v1/admin/transaction",
  statususer: "/v1/admin/user/change-status",
  getSubAdmin: "/v1/admin/subadmin/list",
  editSubAdmin: "/v1/admin/subadmin/edit",
  addSubAdmin: "/v1/admin/subadmin/add",
  deleteSubAdmin: "/v1/admin/subadmin/delete",
  statusSub: "/v1/admin/subadmin/change-status",
  addMerchant: "/v1/admin/merchant",
  editMerchant: "/v1/admin/merchant",
  getMerchantList: "/v1/admin/merchant/list",
  deleteMerchant: "/v1/admin/merchant",
  changeMerchantStatus: "/v1/admin/merchant/status",
  updateSettings: "/v1/admin/setting",
  updateMcrSettings: "/v1/admin/mcr-settings",
  getSettings: "/v1/admin/setting",
  mortgageSetting: "/v1/admin/setting/mortgage-settings",
  addMortgageSettingBank: "/v1/admin/setting/mortgage-settings/add-bank",
  getMortgageSettingBanks: "/v1/admin/setting/mortgage-settings/banks",
  getMcrSettings: "/v1/admin/mcr-settings",
  changeMerchantVerified: "/v1/admin/merchant/verify",
  getFAQs: "/v1/admin/faqs",
  getFAQsCategories: "/v1/admin/faqs/categories",
  importFAQs: "/v1/admin/faqs/import-faqs",
  getContactUs: "/v1/admin/contact-us",
  changeFAQStatus: "/v1/admin/faqs/status",
  getStaticContent: "/v1/admin/static-content",
  forgotPassword: "/v1/admin/forgot-password",
  resetPassword: "/v1/admin/reset-password",
  changePassword: "/v1/admin/change-password",
  editProfile: "/v1/admin/edit-profile",
  getAllOffers: "/v1/admin/offers",
  getUserDetails: "/v1/admin/user/details",
  getDashboardDetails: "/v1/admin/dashboard",
  getReports: "/v1/admin/report",
  downloadReport: "/v1/admin/download-report",
  getMicroCreditLoanSlabs: "/v1/admin/micro-credit-loan-slabs",
  getMicroCreditLoanRequests: "/v1/admin/loans",
  ChangeStatusMicroCreditLoanRequests: "/v1/admin/loans/change-status",
  subcategoryList: "/v1/admin/subcategory",
  subCategoryStatus: "/v1/admin/subcategory/change-status",
  deleteSubCategory: "/v1/admin/subcategory",
  subcategoryAdd: "/v1/admin/subcategory",
  subcategoryUpdate: "/v1/admin/subcategory",
  categoryList: "/v1/admin/category",
  categoryStatus: "/v1/admin/category/change-status",
  deleteCategory: "/v1/admin/category",
  categoryAdd: "/v1/admin/category",
  categoryUpdate: "/v1/admin/category",
  orders: "/v1/admin/orders",
  orderDiscounts: "/v1/admin/order-discounts",
  changeOfferStatus: "/v1/admin/offers/change-status",
  propertyTypesList: "/v1/admin/property-types",
  changePropertyTypesStatus: "/v1/admin/property-types/change-status",
  propertyCategoryList: "/v1/admin/property-category",
  changePropertyCategoryStatus: "/v1/admin/property-category/change-status",
  editPropertyCategory: "/v1/admin/property-category",
  listPropertyType: "/v1/admin/property-types/list",
  addPropertyCategory: "/v1/admin/property-category",
  getAllCompany: "/v1/admin/company",
  changeCompanyStatus: "/v1/admin/company/change-status",
  getAgents: "/v1/admin/agent",
  searchAgent: "/v1/admin/agent/search",
  freelancerAgents: "/v1/admin/agent/freelancers",
  statusAgent: "/v1/admin/agent/change-status",
  deleteAgent: "/v1/admin/agent/delete",
  addAgent: "/v1/admin/agent",
  agentRoles: "/v1/admin/agent/roles",
  bannerList: "/v1/admin/banner",
  sliderSetting: "/v1/admin/banner/slider-setting",
  changeBannerStatus: "/v1/admin/banner/change-status",
  changeSliderSettingStatus: "/v1/admin/banner/slider-setting/change-status",
  ListAmenities: "/v1/admin/amenities",
  ListTopMenus: "/v1/admin/top-bar-menus",
  ListSubscriptions: "/v1/admin/subscription",
  changeStatusSubscription: "/v1/admin/subscription/change-status",
  changeStatusAmenities: "/v1/admin/amenities/change-status",
  changeStatusTopBarMenu: "/v1/admin/top-bar-menus/change-status",
  ListBlog: "/v1/admin/blogs",
  blogFaqs: "/v1/admin/blog-faqs",
  uploadBlogImage: "/v1/admin/blogs/upload-image",
  changeStatusBlog: "/v1/admin/blogs/change-status",
  bannerAdd: "/v1/admin/banner",
  homeBannerAdd: "/v1/admin/banner",
  editBanner: "/v1/admin/banner",
  addHomeAd: "/v1/admin/banner/home-add-adBanner",
  editHomeAd: "/v1/admin/banner/home-edit-adBanner",
  getSideBanner: "/v1/admin/banner/side-banner",
  getHomeAdBanner: "/v1/admin/banner/home-ad-banner",
  editSideBanner: "/v1/admin/banner/side-banner",
  marketingList: "/v1/admin/marketing-manager",
  queryList: "/v1/admin/queries",
  deleteReportQuery: "/v1/admin/queries/delete-report-query",
  queryChangeStatus: "/v1/admin/queries/change-status",
  requirementList: "/v1/admin/queries/requirement",
  deleteRequirementQuery: "/v1/admin/queries/delete-requirement-query",
  projectContactList: "/v1/admin/queries/project-contact",
  projectContactQueryDelete: "/v1/admin/queries/delete-project-contact-query",
  queryPropertyList: "/v1/admin/queries/list-property",
  deletePropertyListingQuery: "/v1/admin/queries/delete-property-listing-query",
  queryBlogList: "/v1/admin/queries/blog-list",
  deleteBlogListQuery: "/v1/admin/queries/delete-blog-list-query",
  contactUsList: "/v1/admin/queries/contactUs",
  deleteContactUsQuery: "/v1/admin/queries/delete-contactus-query",
  suggestionsAndComplaintsList: "/v1/admin/queries/suggestions-and-complaints",
  deleteSuggestionComplaintQuery:
    "/v1/admin/queries/delete-suggestions-and-complaints-query",
  sendReplyMessage: "/v1/admin/queries/reply",
  Addmarketing: "/v1/admin/marketing-manager",
  notifications: "/v1/admin/notifications",
  notificationRecipientsCount: "/v1/admin/notifications/recipients-count",
  getBellNotification: "/v1/admin/notifications/list",
  marketingManagerSearchUser: "/v1/admin/marketing-manager/search-user",
  Properties: "/v1/admin/properties",
  AddProperty: "/v1/admin/properties",
  uploadPhotos: "/v1/admin/properties/upload-photos",
  propertyDetailsById: "/v1/admin/properties/property-details",
  PropertiesMasterData: "/v1/admin/properties/master-data",
  propertyAmenity: "/v1/admin/properties/amenity-data",
  getAuctions: "/v1/admin/auctions",
  endAuction: "/v1/admin/auctions/end-auction",
  acceptAuction: "/v1/admin/auctions/accept-bid",
  getAuctionsDetailsById: "/v1/admin/auctions/auction-details",
  changeStatusAuctions: "/v1/admin/auctions/change-status",
  getReportsBidding: "/v1/admin/reports/bidding",
  getReportsSubscription: "/v1/admin/reports/subscription",
  getApprovalAppointments: "/v1/admin/approval/appointments",
  getUserAuctions: "/v1/admin/user/auction-details",
  approvalAppointmentsStatusChange:
    "/v1/admin/approval/change-appointment-status",
  getApprovalCompanies: "/v1/admin/approval/company-approval",
  approvalCompanyStatusChange: "/v1/admin/approval/change-company-status",
  getPropertyApproval: "/v1/admin/approval/property-approval",
  approvalPropertyStatusChange: "/v1/admin/approval/change-property-status",
  getAgentApproval: "/v1/admin/approval/agent-approval",
  approvalAgentStatusChange: "/v1/admin/approval/change-agent-status",
  getCompanyAgentList: "/v1/admin/company/agent-list",
  getCompanyPropertyList: "/v1/admin/company/property-list",
  ChangeStatusProperties: "/v1/admin/properties/change-status",
  ChangeSoldStatusProperties: "/v1/admin/properties/mark-sold",
  appointmentDetails: "/v1/admin/appointments",
  appointmentCompanyList: "/v1/admin/company/appointment-list",
  appointmentUserList: "/v1/admin/user/appointment-list",
  appointmentAgentList: "/v1/admin/agent/appointment-list",
  agentProperties: "/v1/admin/agent/property-list",
  propertyFeature: "/v1/admin/properties/feature",
  projectPath: "/v1/admin/projects",
  projectHistoryPath: "/v1/admin/projects",
  agentList: "v1/admin/agent/list",
  ChangeStatusProjects: "/v1/admin/projects/change-status",
  getCities: "/v1/user/cities",
  getUserMasterData: "/v1/user/master-data",
  getCommunities: "/v1/user/community",
  addAddressProperty: "/v1/admin/properties/address",
  reasonReportList: "/v1/admin/report-reasons",
  reasonReportAdd: "/v1/admin/report-reasons",
  reasonReportStatus: "/v1/admin/report-reasons/change-status",
  reasonReportEdit: "/v1/admin/report-reasons",
  getActiveSubscription: "/v1/admin/company/active-subscription",
  rearrangePhotos: "/v1/companies/properties/rearrange-photos",
  rearrangeProjectPhotos: "/v1/admin/projects/rearrange-photos",
  getNotification: "/v1/admin/check-notification",
  citiesList: "/v1/admin/cities",
  citiesListForAddress: "/v1/admin/properties/cities",
  communityListByCityId: "/v1/admin/properties/communities",
  subCommunityListByCommunityId: "/v1/admin/properties/sub-communities",
  uploadTemporaryPhotos: "/v1/admin/properties/temporary-photo",
  deleteTempPhoto: "/v1/admin/properties/delete-temporary-photo/",
  updateSequence: "/v1/admin/property-category/change-sequence",
  unitPath: "/v1/admin/units",
  unitHistoryPath: "/v1/admin/units",
  unitImportPath: "/v1/admin/units/import-units",
  unitExportPath: "/v1/admin/units/export-units",
  allCommunities: "/v1/admin/communities/all-communities",
  discoverCommunities: "/v1/admin/discover-communities",
  propertiesPromotions: "/v1/admin/properties-presentation",
  projectPresentation: "/v1/admin/projects-presentation",
  unitPresentation: "/v1/admin/units-presentation",
  projectStatus: "/v1/admin/project-status",
  updateProjectStatus: "/v1/admin/project-status/change-status",
  getProjectStatus: "/v1/admin/projects/project-status",
  getProjectType: "/v1/admin/projects/project-type",
  appHomeMenu: "/v1/admin/app-home-menu",
  updateAppHomeMenu: "/v1/admin/app-home-menu/change-status",
  availableStatus: "v1/admin/projects/available-status",
  getPropertyPlans: "/v1/admin/properties/plans",
  locationCommunities: "/v1/admin/communities",
  locationSubCommunities: "/v1/admin/sub-communities",
  advertisementValidator: "/v1/admin/properties/advertisement-validator",
  getRegaInfo: "/v1/admin/properties/rega-info",
  subAdminResetPassword: "/v1/admin/subadmin/reset-password",
  agentResetPassword: "/v1/admin/agent/reset-password",
  projectFloors: "/v1/admin/project-floors",
  projectFloor: "/v1/admin/project-floors",
  ChangeStatusUnit: "/v1/admin/units/change-status",
  getUnitsReportSummary: "/v1/admin/units-report/summary",
  getUnitsReportProjects: "/v1/admin/units-report/projects",
  // Careers Module (Admin)
  careers: "/v1/admin/careers",
  careerById: "/v1/admin/careers",
  careersChangeStatus: "/v1/admin/careers/change-status",
  careerApplicationsList: "/v1/admin/careers/applications/list",
  careerApplicationById: "/v1/admin/careers/applications",
  careerApplicationUpdateStatus: "/v1/admin/careers/applications/update-status",
  careerApplicationAssignRecruiter: "/v1/admin/careers/applications/assign-recruiter",
  careersStatsOverview: "/v1/admin/careers/stats/overview",
  careerRecruiters: "/v1/admin/careers/recruiters",
  careerRecruitersAll: "/v1/admin/careers/recruiters/all",
  careerRecruiterById: "/v1/admin/careers/recruiters",
  resumeCatalog: "/v1/admin/resume-catalog",

  // Tests
  quizTests: "/v1/admin/quiz/test",
  quizQuestions: "/v1/admin/quiz/questions",
  quizQuestionBank: "/v1/admin/quiz/question-bank",
  quizTestSubmissions: "/v1/admin/quiz/submissions",
  quizTestSubmissionsExport: "/v1/admin/quiz/submissions/export",

  // Training Sessions
  trainingSessions: "/v1/admin/trainingSessions",
  trainingSubmissions: "/v1/admin/trainingSessions/submissions",

  // Activity Tracker
  activityOverview: "/v1/admin/activities/overview",
  activityFeed: "/v1/admin/activities/feed",
  activityAgent: "/v1/admin/activities/agents",
  activityFilterOptions: "/v1/admin/activities/filter-options",

  // Bank Manager
  banks: "/v1/admin/banks",

  // Onboarding Candidates
  onboardingCandidatesList: "/v1/admin/onboarding-candidates",
  onboardingCandidateById: "/v1/admin/onboarding-candidates",
};

export default apiPath;
